module.exports = __webpack_public_path__ + "img/dirActive - 副本.83a0b120.png";